import React from 'react'; 

const Home = () => {
     
    return  <>
        Home Page
        </>;
};
export default Home;